import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {employeeResourcesTableReady,rowsAttritonPerPageState,searchTextState,paginationAttritionState} from '../redux/employees'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/employeesTable.css'
import * as Helpers from '../../../common/helpers'



//import DateRangePicker from 'react-bootstrap-daterangepicker'
import 'react-bootstrap-daterangepicker/css/daterangepicker.css'
import moment from 'moment'




function filterUnwantedData(employeeResourcesData,typeData) {
    employeeResourcesData=employeeResourcesData.data
    let array = []    

     let types=typeData.data;
      Object.keys(types).map((value,index) => {            
            array.push(types[value])
            return true
        })

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            newLineData.type=array[i]
            newLineData.edit=false
            newLineData.file_id="file_id_"+array[i]
            newLineData.file_name = ""
            newLineData.file_type = ""
            newLineData.file_base64 = ""

            for (var j = 0; j < employeeResourcesData.length; j++) {
                if(employeeResourcesData[j]['type']===array[i]){
                    newLineData.id=employeeResourcesData[j].id ? employeeResourcesData[j].id : ""
                    newLineData.employee_id=employeeResourcesData[j].employee_id ? employeeResourcesData[j].employee_id : ""
                    newLineData.link=employeeResourcesData[j].link ? employeeResourcesData[j].link : ""
                    newLineData.edit=true
                    break;
                }
            }

            newArray[i] = newLineData
        }
    }

    return newArray
}


class AddEditEmployeeResources extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            employeeResourcesData: [],
            employeeData:{},
            bodyHeight: "0px",
            tableHeight: "0px",
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(employeeResourcesTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.EMPLOYEE_RESOURCES_TABLE))

        this.props.dispatch(subHeaderDataUpdate())

        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()

        if (this.props.employees && this.props.employees.employeeResourceSelectedData && this.props.employees.employeeResourceSelectedData !== null) {
            this.getEmployeeResourcessByEmployeeId(this.props.employees.employeeResourceSelectedData.id)
            this.setState({
                employeeData: this.props.employees.employeeResourceSelectedData
            });
        }else{
            this.props.history.goBack()
        }

        
        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }
    
    getEmployeeResourcessByEmployeeId = (id) => {
        apiService.getEmployeeResourcessByEmployeeId(id)
            .then(responseData => {
                if (responseData && this.isComponentMounted) {
                    this.validateBuildNumber(responseData)
                    if (responseData.status === "SUCCESS") {
                        this.getResoucesTypes(responseData)
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
            })
            .catch(err => {
                console.error("Error data: ", err)                
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }



    getResoucesTypes = (resource_data) => {
        
        apiService.getEntyTypesList("EMPLOYEE_RESOURCES")
            .then(typeData => {
                if (typeData && this.isComponentMounted) {
                    this.validateBuildNumber(typeData)
                    if (typeData.status === "SUCCESS") {

                        let array = filterUnwantedData(resource_data,typeData)

                        this.setState({
                            employeeResourcesData: array
                        });

                         
                        
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: typeData.reason ? typeData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                    this.props.dispatch(employeeResourcesTableReady(true))
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(employeeResourcesTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.employees && this.props.employees.previousAttritionRowsPerPageValue) {
            value = this.props.employees.previousAttritionRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsAttritonPerPageState(value))
        this.dropUpManager()
    }






  uploadFile = (row) =>{


    let employeeResourcesData = this.state.employeeResourcesData;
    let selectedDocument={}




    this.props.dispatch(employeeResourcesTableReady(false))
    let data = {}


    employeeResourcesData.map(function(item, index) {
            if (item['file_id'] === row.file_id) {
                selectedDocument=item
            }
            return true
    })


    if(selectedDocument.file_base64!=="" && selectedDocument.file_base64!==undefined){
        data.file_data=selectedDocument.file_base64
        data.file_name=selectedDocument.file_name
        data.file_type=selectedDocument.file_type
        data.type=selectedDocument.type
    }else{

        this.props.dispatch(employeeResourcesTableReady(true))
            this.dialog.show({
                    title: "Error",
                    body: 'Please select file for '+selectedDocument.type,
                    actions: [
                        Dialog.OKAction(() => {
                        })
                    ],
                })

        return
    }




    data.employee_id=this.props.employees.employeeResourceSelectedData.id;

    let apiPayloadData=data;


    if(row.edit){
        
         apiService.editEmployeeResource(apiPayloadData,row.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(employeeResourcesTableReady(true))
                        window.location.reload()
                    } else {

                        this.props.dispatch(employeeResourcesTableReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(employeeResourcesTableReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })

    }else{

        

        apiService.addEmployeeResource(apiPayloadData)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(employeeResourcesTableReady(true))
                        window.location.reload()
                    } else {

                        this.props.dispatch(employeeResourcesTableReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(employeeResourcesTableReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })

        

    }

    
}

  deleteEmployeeResources = (row) =>{
        
        if (window.confirm("Are you sure?") === true) {
            this.props.dispatch(employeeResourcesTableReady(false))
             apiService.deleteEmployeeResource(row.id)
            .then(responseData => {                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(employeeResourcesTableReady(true))
                        window.location.reload();                        
                    } else {

                        this.props.dispatch(employeeResourcesTableReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(employeeResourcesTableReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })
        
        } 
    }



   

    createCustomToolBar = props => {


        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
               <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 header-div-margins" style={{background:"white",paddingTop:"1%"}}>
                                    <div className="col-md-3 col-sm-12 col-xs-12">
                                         <div className="form-group">
                                                 <label className=" control-label labels" style={{textAlign: "left", paddingTop: "0px"}}>Name : </label>
                                                    {(() => {
                                                        if(this.state.employeeData.name && this.state.employeeData.name!=="" && this.state.employeeData.name!==undefined){
                                                            return(
                                                                <span>{this.state.employeeData.name}</span>
                                                            )
                                                        }else{
                                                            return(
                                                                <span>NA</span>
                                                            )
                                                        }
                                                    })()} 
                                              </div>
                                           </div> 
                                            <div className="col-md-3 col-sm-12 col-xs-12">
                                              <div className="form-group">
                                                 <label className=" control-label labels" style={{textAlign: "left", paddingTop: "0px"}}>Employee Code : </label>
                                                    {(() => {
                                                        if(this.state.employeeData.code && this.state.employeeData.code!=="" && this.state.employeeData.code!==undefined){
                                                            return(
                                                                <span>{this.state.employeeData.code}</span>
                                                            )
                                                        }else{
                                                            return(
                                                                <span>NA</span>
                                                            )
                                                        }
                                                    })()}  
                                              </div>
                                           </div>  

                                           <div className="col-md-3 col-sm-12 col-xs-12">
                                              <div className="form-group">
                                                 <label className="control-label labels" style={{textAlign: "left", paddingTop: "0px"}}>Designation : </label>
                                                    {(() => {
                                                        if(this.state.employeeData.designation_name && this.state.employeeData.designation_name!=="" && this.state.employeeData.designation_name!==undefined){
                                                            return(
                                                                <span>{this.state.employeeData.designation_name}</span>
                                                            )
                                                        }else{
                                                            return(
                                                                <span>NA</span>
                                                            )
                                                        }
                                                    })()}   
                                              </div>
                                           </div>  

                                           

                                           <div className="col-md-3 col-sm-12 col-xs-12">
                                              <div className="form-group">
                                                 <label className=" control-label labels" style={{textAlign: "left", paddingTop: "0px"}}>Department : </label>
                                                    {(() => {
                                                        if(this.state.employeeData.department_name && this.state.employeeData.department_name!=="" && this.state.employeeData.department_name!==undefined){
                                                            return(
                                                                <span>{this.state.employeeData.department_name}</span>
                                                            )
                                                        }else{
                                                            return(
                                                                <span>NA</span>
                                                            )
                                                        }
                                                    })()} 
                                              </div>
                                           </div>  
                                           
                
                                </div>
            </div>
        )
    }
  
     createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                {/*
                    <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.employeeResourcesData.length>=(this.props.employees.previousPaginationAttritionValue*this.props.employees.previousAttritionRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.employees.previousPaginationAttritionValue*this.props.employees.previousAttritionRowsPerPageValue)-this.props.employees.previousAttritionRowsPerPageValue+1} to {this.props.employees.previousPaginationAttritionValue*this.props.employees.previousAttritionRowsPerPageValue} of {this.state.employeeResourcesData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.employees.previousPaginationAttritionValue*this.props.employees.previousAttritionRowsPerPageValue)-this.props.employees.previousAttritionRowsPerPageValue+1} to {this.state.employeeResourcesData.length} of {this.state.employeeResourcesData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            */}
            </div> 
        )   
    }

   
    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

  

     getFilteredList = () => {
       
        this.props.dispatch(employeeResourcesTableReady(false))
        this.resetSearchAndPagination()
        this.getEmployeeResourcesData()
       
    }



    resetFilterValues = () => {
        this.props.dispatch(employeeResourcesTableReady(false))
        this.setState({
            startDate: moment().startOf('month'),
            endDate: moment().format("YYYY-MM-DD"),
            filter_status:""
        },() => {
             this.resetPagination()
        
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")

        this.getEmployeeResourcesData();
        });

       

        
    }


handleOnChange = (e) => {
    let employeeResourcesData = this.state.employeeResourcesData;
    let file=e.target.files[0]
    let file_id=e.target.id
    let file_name = e.target.files[0].name
    let file_type = e.target.files[0].type

    let stateObj=this

    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {

        let base64=reader.result

        base64=base64.split(",");

        base64=base64[base64.length-1];

         employeeResourcesData.map(function(item, index) {
            if (item['file_id'] === file_id) {
                item.file_name = file_name
                item.file_type = file_type
                item.file_base64 = base64
            }
            return true
        })

        stateObj.setState({
            employeeResourcesData: employeeResourcesData
        });    
        
       };
       reader.onerror = function (error) {
         console.log('Error: ', error);
       }; 

       
};






    renderUploadWizard = (cell, row) => {

        let response=""


        if(row.edit){
            response=<div><a href={row.link} style={{color:"blue",textDecoration: "underline"}} target="_Blank"><i class="fa fa-eye" aria-hidden="true"></i> View Document</a><br/><br/><input  type={"file"}
                            id={row.file_id}
                            accept={".pdf,.png,.jpg,.docx"}
                            onChange={this.handleOnChange}
                             />
                             </div>

        }else{
           response=<input  type={"file"}
                            id={row.file_id}
                            accept={".pdf,.png,.jpg,.docx"}
                            onChange={this.handleOnChange}
                             />
        }


        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{response}</div>
        </div>)

    }



    actionButtonsCreator = (cell, row) => {

        let deleteEmployeeResources = ""
        let updateEmployeeResources = ""
        let uploadFile = ""

    
        if(row.edit){


             if(Helpers.checkPrivileges("/dashboard/employee/resources/delete",this.props.user)){

                    deleteEmployeeResources =       
                    <button title="Delete This Resource"
                        className="action-button"
                        style={{ width: "70px", marginBottom: "1px",background:"red" }}
                        onClick={(e) => {
                            e.preventDefault()
                            this.deleteEmployeeResources(row)
                        }}>
                        <i title="Delete This Resource" className="fa fa-trash" aria-hidden="true"></i> Delete
                    </button>

                updateEmployeeResources =       
                    <button title="upload"
                        className="action-button"
                        style={{ width: "70px", marginBottom: "1px",background:"orange" }}
                        onClick={(e) => {
                            e.preventDefault()
                            this.uploadFile(row)
                        }}>
                        <i title="upload" className="fa fa-pencil-square-o" aria-hidden="true"></i> Update
                    </button>

                }
        
            }else{

                 if(Helpers.checkPrivileges("/dashboard/employee/resources/delete",this.props.user)){

                    uploadFile =       
                    <button title="upload"
                        className="action-button"
                        style={{ width: "70px", marginBottom: "1px",background:"green" }}
                        onClick={(e) => {
                            e.preventDefault()
                            this.uploadFile(row)
                        }}>
                        <i title="upload" className="fa fa-pencil-square-o" aria-hidden="true"></i> Upload
                    </button>

                }
            }

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{updateEmployeeResources}{uploadFile}{deleteEmployeeResources}</div>
        </div>)
    }

     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationAttritionState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.employees && this.props.employees.previousPaginationValue
            && this.props.employees.previousPaginationValue !== 1) {
            this.props.dispatch(paginationAttritionState(1))
            this.setState({
                page: 1
            })
        }
    }

   
   


    
    render() {
        let sizeperPage = 15

        if (this.props.employees && this.props.employees.previousAttritionRowsPerPageValue) {
            sizeperPage = this.props.employees.previousAttritionRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (
            <div className="employeesAttrition-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.employeeResourcesData}
                    pagination={true}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight}}                   
                    >

                    <TableHeaderColumn
                        dataField="id"
                        //width="1"
                        isKey={true}
                        hidden={true}                       
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Id
                    </TableHeaderColumn>


                    <TableHeaderColumn
                        dataField="type"
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Type
                    </TableHeaderColumn>


                    <TableHeaderColumn
                        dataField="id"
                        dataFormat={this.renderUploadWizard}
                        dataAlign='left'
                        filterFormatted={true}
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Upload Wizard / Link
                    </TableHeaderColumn>                    


                     <TableHeaderColumn
                        dataField="id"
                        dataFormat={this.actionButtonsCreator}
                        filterFormatted={true}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Actions
                    </TableHeaderColumn>
                </BootstrapTable>
            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        employees: state.employees
    }
}

export default connect(mapStateToProps)(withRouter(AddEditEmployeeResources))


// WEBPACK FOOTER //
// ./src/modules/Employees/Components/AddEditEmployeeResources.js